import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "c-sidebar relative lg:w-1/3 w-full border-b mb-5 lg:mb-0 min-h-full border-r border-neutral-base",
  "aria-label": "Sidebar"
}
const _hoisted_2 = { class: "c-sidebar__mobile lg:hidden pt-3 pb-5 container sm:px-10 border-neutral-base" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  fill: "none",
  stroke: "#5A44A0",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-lg font-semibold text-primary-base" }, "Filtros", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "c-sidebar__state mb-10 mt-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "text-primary-base text-xl font-bold mb-3" }, "Estado", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "estados",
  class: "sr-only"
}, "Selecione um Estado", -1)
const _hoisted_9 = {
  key: 0,
  value: "",
  selected: "",
  disabled: ""
}
const _hoisted_10 = ["value", "selected"]
const _hoisted_11 = { class: "c-sidebar__role mb-10" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-primary-base text-xl font-bold mb-3" }, "Cargo")
], -1)
const _hoisted_13 = {
  class: "py-1",
  "aria-labelledby": "user-menu-button"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "c-sidebar__state mb-10" }
const _hoisted_16 = { class: "flex justify-between items-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", { class: "text-primary-base text-xl font-bold mb-3" }, "Partidos", -1)
const _hoisted_18 = { class: "inline-flex flex-wrap" }
const _hoisted_19 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        "data-collapse-toggle": "sidebar-candidates",
        type: "button",
        class: "inline-flex items-center p-2 ml-3 text-sm rounded-lg ring-2 ring-primary-base hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary-base",
        "aria-controls": "sidebar-candidates",
        "aria-expanded": "false",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpenSidebar = !_ctx.isOpenSidebar))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["lg:sticky lg:top-20 lg:block lg:w-auto px-6 py-3", _ctx.isOpenSidebar ? 'd-block' : 'hidden']),
      id: "sidebar-candidates"
    }, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("select", {
          id: "localeListCandidates",
          name: "localeListCandidates",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.localeListCandidates && _ctx.localeListCandidates(...args))),
          class: "bg-neutral-light border-neutral-light sidebar py-3 px-5 text-neutral-baseDark text-sm rounded-full font-regular focus:ring-secondary-base focus:border-secondary-base block w-full"
        }, [
          (_ctx.currentLocale.initials === 'br')
            ? (_openBlock(), _createElementBlock("option", _hoisted_9, " Selecione um estado "))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.locales, (locale, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: locale.initials,
              selected: 
              _ctx.currentLocale.initials !== locale.initials ? false : true
            
            }, _toDisplayString(locale.name), 9, _hoisted_10))
          }), 128))
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", null, [
          _createElementVNode("ul", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.roles, (role) => {
              return (_openBlock(), _createElementBlock("li", {
                key: role.id,
                class: _normalizeClass(
                role.id === _ctx.currentRole
                  ? 'border-l-8 border-primary-base bg-gray-100'
                  : 'border-l-4 border-transparent'
              )
              }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: ($event: any) => (_ctx.selectRole(role.id)),
                  class: "py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 flex justify-between w-full"
                }, [
                  _createElementVNode("span", null, _toDisplayString(role.name), 1)
                ], 8, _hoisted_14)
              ], 2))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearParty())),
            class: "text-neutral-baseMedium text-sm underline hover:no-underline"
          }, " Limpar ")
        ]),
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reduceParty, (item) => {
            return (_openBlock(), _createElementBlock("button", {
              type: "button",
              onClick: ($event: any) => (
              item.party == _ctx.currentParty
                ? _ctx.clearParty()
                : _ctx.selectParty(item.party)
            ),
              class: _normalizeClass(["px-4 py-2 mr-2 mb-2 rounded font-light text-xs flex align-center w-max cursor-pointer actived:bg-secondary-base hover:bg-secondary-base hover:text-primary-base transition duration-300 ease", 
              item.party == _ctx.currentParty
                ? 'text-primary-base bg-secondary-base'
                : 'text-black bg-neutral-light'
            ]),
              key: item.party
            }, _toDisplayString(item.party), 11, _hoisted_19))
          }), 128))
        ])
      ])
    ], 2)
  ]))
}